//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './SurveyClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetSurveysSurveyQueryParameters = {
  surveyIds?: number[] | null | null;
  studyIds?: number[] | null | null;
  canBeTriggeredByDoctor?: boolean | null | null;
  canBeTriggeredByPatient?: boolean | null | null;
  canBeFilledByDoctor?: boolean | null | null;
};

export type GetLastSurveysStatisticsSurveyQueryParameters = {
  patientId?: string | null;
};

export type GetAnswersStatisticSurveyQueryParameters = {
  patientId?: string | null;
  surveyType?: string | null;
};

export type GetAnswerStatisticSurveyQueryParameters = {
  answerId: number;
  patientId?: string | null;
};

export type GetAnswersSurveyQueryParameters = {
  patientIds?: string[] | null | null;
  surveyIds?: number[] | null | null;
  questionnaireIds?: number[] | null | null;
  answeredBy?: string[] | null | null;
  surveyTypes?: string[] | null | null;
  createdAfter?: Date | null | null;
  createdBefore?: Date | null | null;
  answerIds?: number[] | null | null;
};

export type GetQuestionnairesSurveyQueryParameters = {
  patientId?: string | null | null;
  surveyIds?: number[] | null | null;
  triggeredByCurrentUser?: boolean | null | null;
  triggeredByDoctor?: boolean | null | null;
  triggeredByPatient?: boolean | null | null;
  ended?: boolean | null | null;
  active?: boolean | null | null;
  completed?: boolean | null | null;
  canBeFilledByDoctor?: boolean | null | null;
  forDisplayToPatient?: boolean | null | null;
};

export type GetPredictedQuestionnairesSurveyQueryParameters = {
  patientId?: string | null;
  surveyIds?: number[] | null | null;
};

export type GetSurveyRecordsForPatientSurveyQueryParameters = {
  surveyType?: string | null;
};

export type GetSurveyRulesByStudySurveyQueryParameters = {
  studyId: number;
  groupId?: number | null | null;
};

    
export function getSurveysUrl(surveyIds?: number[] | null | undefined, studyIds?: number[] | null | undefined, canBeTriggeredByDoctor?: boolean | null | undefined, canBeTriggeredByPatient?: boolean | null | undefined, canBeFilledByDoctor?: boolean | null | undefined): string {
  let url_ = getBaseUrl() + "/api/survey/surveys?";
if (surveyIds !== undefined && surveyIds !== null)
    surveyIds && surveyIds.forEach(item => { url_ += "SurveyIds=" + encodeURIComponent("" + item) + "&"; });
if (studyIds !== undefined && studyIds !== null)
    studyIds && studyIds.forEach(item => { url_ += "StudyIds=" + encodeURIComponent("" + item) + "&"; });
if (canBeTriggeredByDoctor !== undefined && canBeTriggeredByDoctor !== null)
    url_ += "CanBeTriggeredByDoctor=" + encodeURIComponent("" + canBeTriggeredByDoctor) + "&";
if (canBeTriggeredByPatient !== undefined && canBeTriggeredByPatient !== null)
    url_ += "CanBeTriggeredByPatient=" + encodeURIComponent("" + canBeTriggeredByPatient) + "&";
if (canBeFilledByDoctor !== undefined && canBeFilledByDoctor !== null)
    url_ += "CanBeFilledByDoctor=" + encodeURIComponent("" + canBeFilledByDoctor) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getSurveysDefaultOptions: UseQueryOptions<Types.SurveyDto[], unknown, Types.SurveyDto[]> = {
  queryFn: __getSurveys,
};
export function getGetSurveysDefaultOptions(): UseQueryOptions<Types.SurveyDto[], unknown, Types.SurveyDto[]> {
  return getSurveysDefaultOptions;
};
export function setGetSurveysDefaultOptions(options: UseQueryOptions<Types.SurveyDto[], unknown, Types.SurveyDto[]>) {
  getSurveysDefaultOptions = options;
}

export function getSurveysQueryKey(dto: GetSurveysSurveyQueryParameters): QueryKey;
export function getSurveysQueryKey(surveyIds?: number[] | null | undefined, studyIds?: number[] | null | undefined, canBeTriggeredByDoctor?: boolean | null | undefined, canBeTriggeredByPatient?: boolean | null | undefined, canBeFilledByDoctor?: boolean | null | undefined): QueryKey;
export function getSurveysQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { surveyIds, studyIds, canBeTriggeredByDoctor, canBeTriggeredByPatient, canBeFilledByDoctor,  } = params[0] as GetSurveysSurveyQueryParameters;

    return trimArrayEnd([
        'SurveyClient',
        'getSurveys',
        surveyIds as any,
        studyIds as any,
        canBeTriggeredByDoctor as any,
        canBeTriggeredByPatient as any,
        canBeFilledByDoctor as any,
      ]);
  } else {
    return trimArrayEnd([
        'SurveyClient',
        'getSurveys',
        ...params
      ]);
  }
}
function __getSurveys(context: QueryFunctionContext) {
  return Client.getSurveys(
      context.queryKey[2] as number[] | null | undefined,       context.queryKey[3] as number[] | null | undefined,       context.queryKey[4] as boolean | null | undefined,       context.queryKey[5] as boolean | null | undefined,       context.queryKey[6] as boolean | null | undefined    );
}

export function useGetSurveysQuery<TSelectData = Types.SurveyDto[], TError = unknown>(dto: GetSurveysSurveyQueryParameters, options?: UseQueryOptions<Types.SurveyDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetSurveysQuery<TSelectData = Types.SurveyDto[], TError = unknown>(surveyIds?: number[] | null | undefined, studyIds?: number[] | null | undefined, canBeTriggeredByDoctor?: boolean | null | undefined, canBeTriggeredByPatient?: boolean | null | undefined, canBeFilledByDoctor?: boolean | null | undefined, options?: UseQueryOptions<Types.SurveyDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetSurveysQuery<TSelectData = Types.SurveyDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.SurveyDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let surveyIds: any = undefined;
  let studyIds: any = undefined;
  let canBeTriggeredByDoctor: any = undefined;
  let canBeTriggeredByPatient: any = undefined;
  let canBeFilledByDoctor: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ surveyIds, studyIds, canBeTriggeredByDoctor, canBeTriggeredByPatient, canBeFilledByDoctor,  } = params[0] as GetSurveysSurveyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [surveyIds, studyIds, canBeTriggeredByDoctor, canBeTriggeredByPatient, canBeFilledByDoctor, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.SurveyDto[], TError, TSelectData>({
    queryFn: __getSurveys,
    queryKey: getSurveysQueryKey(surveyIds, studyIds, canBeTriggeredByDoctor, canBeTriggeredByPatient, canBeFilledByDoctor),
    ...getSurveysDefaultOptions as unknown as UseQueryOptions<Types.SurveyDto[], TError, TSelectData>,
    ...options,
  });
}

export function setGetSurveysData(queryClient: QueryClient, updater: (data: Types.SurveyDto[] | undefined) => Types.SurveyDto[], surveyIds?: number[] | null | undefined, studyIds?: number[] | null | undefined, canBeTriggeredByDoctor?: boolean | null | undefined, canBeTriggeredByPatient?: boolean | null | undefined, canBeFilledByDoctor?: boolean | null | undefined) {
  queryClient.setQueryData(getSurveysQueryKey(surveyIds, studyIds, canBeTriggeredByDoctor, canBeTriggeredByPatient, canBeFilledByDoctor),
    updater
  );
}

export function setGetSurveysDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.SurveyDto[] | undefined) => Types.SurveyDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getLastSurveysStatisticsUrl(patientId?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/survey/lastSurveysStatistics?";
if (patientId === null)
    throw new Error("The parameter 'patientId' cannot be null.");
else if (patientId !== undefined)
    url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getLastSurveysStatisticsDefaultOptions: UseQueryOptions<{ [key: string]: Types.SurveyStatisticsDto; }, unknown, { [key: string]: Types.SurveyStatisticsDto; }> = {
  queryFn: __getLastSurveysStatistics,
};
export function getGetLastSurveysStatisticsDefaultOptions(): UseQueryOptions<{ [key: string]: Types.SurveyStatisticsDto; }, unknown, { [key: string]: Types.SurveyStatisticsDto; }> {
  return getLastSurveysStatisticsDefaultOptions;
};
export function setGetLastSurveysStatisticsDefaultOptions(options: UseQueryOptions<{ [key: string]: Types.SurveyStatisticsDto; }, unknown, { [key: string]: Types.SurveyStatisticsDto; }>) {
  getLastSurveysStatisticsDefaultOptions = options;
}

export function getLastSurveysStatisticsQueryKey(patientId?: string | undefined): QueryKey;
export function getLastSurveysStatisticsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { patientId,  } = params[0] as GetLastSurveysStatisticsSurveyQueryParameters;

    return trimArrayEnd([
        'SurveyClient',
        'getLastSurveysStatistics',
        patientId as any,
      ]);
  } else {
    return trimArrayEnd([
        'SurveyClient',
        'getLastSurveysStatistics',
        ...params
      ]);
  }
}
function __getLastSurveysStatistics(context: QueryFunctionContext) {
  return Client.getLastSurveysStatistics(
      context.queryKey[2] as string | undefined    );
}

export function useGetLastSurveysStatisticsQuery<TSelectData = { [key: string]: Types.SurveyStatisticsDto; }, TError = unknown>(dto: GetLastSurveysStatisticsSurveyQueryParameters, options?: UseQueryOptions<{ [key: string]: Types.SurveyStatisticsDto; }, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns list of created surveys for given study and user.
 * @param patientId (optional) Id of the patient for requested survey statistic
 */
export function useGetLastSurveysStatisticsQuery<TSelectData = { [key: string]: Types.SurveyStatisticsDto; }, TError = unknown>(patientId?: string | undefined, options?: UseQueryOptions<{ [key: string]: Types.SurveyStatisticsDto; }, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetLastSurveysStatisticsQuery<TSelectData = { [key: string]: Types.SurveyStatisticsDto; }, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<{ [key: string]: Types.SurveyStatisticsDto; }, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let patientId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ patientId,  } = params[0] as GetLastSurveysStatisticsSurveyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [patientId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<{ [key: string]: Types.SurveyStatisticsDto; }, TError, TSelectData>({
    queryFn: __getLastSurveysStatistics,
    queryKey: getLastSurveysStatisticsQueryKey(patientId),
    ...getLastSurveysStatisticsDefaultOptions as unknown as UseQueryOptions<{ [key: string]: Types.SurveyStatisticsDto; }, TError, TSelectData>,
    ...options,
  });
}
/**
 * Returns list of created surveys for given study and user.
 * @param patientId (optional) Id of the patient for requested survey statistic
 */
export function setGetLastSurveysStatisticsData(queryClient: QueryClient, updater: (data: { [key: string]: Types.SurveyStatisticsDto; } | undefined) => { [key: string]: Types.SurveyStatisticsDto; }, patientId?: string | undefined) {
  queryClient.setQueryData(getLastSurveysStatisticsQueryKey(patientId),
    updater
  );
}

/**
 * Returns list of created surveys for given study and user.
 * @param patientId (optional) Id of the patient for requested survey statistic
 */
export function setGetLastSurveysStatisticsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: { [key: string]: Types.SurveyStatisticsDto; } | undefined) => { [key: string]: Types.SurveyStatisticsDto; }) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getAnswersStatisticUrl(patientId?: string | undefined, surveyType?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/survey/answers/statistic?";
if (patientId === null)
    throw new Error("The parameter 'patientId' cannot be null.");
else if (patientId !== undefined)
    url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
if (surveyType === null)
    throw new Error("The parameter 'surveyType' cannot be null.");
else if (surveyType !== undefined)
    url_ += "surveyType=" + encodeURIComponent("" + surveyType) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAnswersStatisticDefaultOptions: UseQueryOptions<Types.AnswersStatisticsDto, unknown, Types.AnswersStatisticsDto> = {
  queryFn: __getAnswersStatistic,
};
export function getGetAnswersStatisticDefaultOptions(): UseQueryOptions<Types.AnswersStatisticsDto, unknown, Types.AnswersStatisticsDto> {
  return getAnswersStatisticDefaultOptions;
};
export function setGetAnswersStatisticDefaultOptions(options: UseQueryOptions<Types.AnswersStatisticsDto, unknown, Types.AnswersStatisticsDto>) {
  getAnswersStatisticDefaultOptions = options;
}

export function getAnswersStatisticQueryKey(dto: GetAnswersStatisticSurveyQueryParameters): QueryKey;
export function getAnswersStatisticQueryKey(patientId?: string | undefined, surveyType?: string | undefined): QueryKey;
export function getAnswersStatisticQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { patientId, surveyType,  } = params[0] as GetAnswersStatisticSurveyQueryParameters;

    return trimArrayEnd([
        'SurveyClient',
        'getAnswersStatistic',
        patientId as any,
        surveyType as any,
      ]);
  } else {
    return trimArrayEnd([
        'SurveyClient',
        'getAnswersStatistic',
        ...params
      ]);
  }
}
function __getAnswersStatistic(context: QueryFunctionContext) {
  return Client.getAnswersStatistic(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as string | undefined    );
}

export function useGetAnswersStatisticQuery<TSelectData = Types.AnswersStatisticsDto, TError = unknown>(dto: GetAnswersStatisticSurveyQueryParameters, options?: UseQueryOptions<Types.AnswersStatisticsDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param patientId (optional) Id of the patient for requested answers
 * @param surveyType (optional) Type of the survey
 * @return Answers statistic for surveys for the whole study of patient
 */
export function useGetAnswersStatisticQuery<TSelectData = Types.AnswersStatisticsDto, TError = unknown>(patientId?: string | undefined, surveyType?: string | undefined, options?: UseQueryOptions<Types.AnswersStatisticsDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAnswersStatisticQuery<TSelectData = Types.AnswersStatisticsDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.AnswersStatisticsDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let patientId: any = undefined;
  let surveyType: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ patientId, surveyType,  } = params[0] as GetAnswersStatisticSurveyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [patientId, surveyType, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.AnswersStatisticsDto, TError, TSelectData>({
    queryFn: __getAnswersStatistic,
    queryKey: getAnswersStatisticQueryKey(patientId, surveyType),
    ...getAnswersStatisticDefaultOptions as unknown as UseQueryOptions<Types.AnswersStatisticsDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * @param patientId (optional) Id of the patient for requested answers
 * @param surveyType (optional) Type of the survey
 * @return Answers statistic for surveys for the whole study of patient
 */
export function setGetAnswersStatisticData(queryClient: QueryClient, updater: (data: Types.AnswersStatisticsDto | undefined) => Types.AnswersStatisticsDto, patientId?: string | undefined, surveyType?: string | undefined) {
  queryClient.setQueryData(getAnswersStatisticQueryKey(patientId, surveyType),
    updater
  );
}

/**
 * @param patientId (optional) Id of the patient for requested answers
 * @param surveyType (optional) Type of the survey
 * @return Answers statistic for surveys for the whole study of patient
 */
export function setGetAnswersStatisticDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.AnswersStatisticsDto | undefined) => Types.AnswersStatisticsDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getAnswerStatisticUrl(answerId: number, patientId?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/survey/answer/{answerId}/statistic?";
if (answerId === undefined || answerId === null)
  throw new Error("The parameter 'answerId' must be defined.");
url_ = url_.replace("{answerId}", encodeURIComponent("" + answerId));
if (patientId === null)
    throw new Error("The parameter 'patientId' cannot be null.");
else if (patientId !== undefined)
    url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAnswerStatisticDefaultOptions: UseQueryOptions<Types.AnswersStatisticsDto, unknown, Types.AnswersStatisticsDto> = {
  queryFn: __getAnswerStatistic,
};
export function getGetAnswerStatisticDefaultOptions(): UseQueryOptions<Types.AnswersStatisticsDto, unknown, Types.AnswersStatisticsDto> {
  return getAnswerStatisticDefaultOptions;
};
export function setGetAnswerStatisticDefaultOptions(options: UseQueryOptions<Types.AnswersStatisticsDto, unknown, Types.AnswersStatisticsDto>) {
  getAnswerStatisticDefaultOptions = options;
}

export function getAnswerStatisticQueryKey(dto: GetAnswerStatisticSurveyQueryParameters): QueryKey;
export function getAnswerStatisticQueryKey(answerId: number, patientId?: string | undefined): QueryKey;
export function getAnswerStatisticQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { answerId, patientId,  } = params[0] as GetAnswerStatisticSurveyQueryParameters;

    return trimArrayEnd([
        'SurveyClient',
        'getAnswerStatistic',
        answerId as any,
        patientId as any,
      ]);
  } else {
    return trimArrayEnd([
        'SurveyClient',
        'getAnswerStatistic',
        ...params
      ]);
  }
}
function __getAnswerStatistic(context: QueryFunctionContext) {
  return Client.getAnswerStatistic(
      context.queryKey[2] as number,       context.queryKey[3] as string | undefined    );
}

export function useGetAnswerStatisticQuery<TSelectData = Types.AnswersStatisticsDto, TError = unknown>(dto: GetAnswerStatisticSurveyQueryParameters, options?: UseQueryOptions<Types.AnswersStatisticsDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param answerId ID of the requested answer
 * @param patientId (optional) Id of the patient for requested answer
 * @return Answer statistic
 */
export function useGetAnswerStatisticQuery<TSelectData = Types.AnswersStatisticsDto, TError = unknown>(answerId: number, patientId?: string | undefined, options?: UseQueryOptions<Types.AnswersStatisticsDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAnswerStatisticQuery<TSelectData = Types.AnswersStatisticsDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.AnswersStatisticsDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let answerId: any = undefined;
  let patientId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ answerId, patientId,  } = params[0] as GetAnswerStatisticSurveyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [answerId, patientId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.AnswersStatisticsDto, TError, TSelectData>({
    queryFn: __getAnswerStatistic,
    queryKey: getAnswerStatisticQueryKey(answerId, patientId),
    ...getAnswerStatisticDefaultOptions as unknown as UseQueryOptions<Types.AnswersStatisticsDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * @param answerId ID of the requested answer
 * @param patientId (optional) Id of the patient for requested answer
 * @return Answer statistic
 */
export function setGetAnswerStatisticData(queryClient: QueryClient, updater: (data: Types.AnswersStatisticsDto | undefined) => Types.AnswersStatisticsDto, answerId: number, patientId?: string | undefined) {
  queryClient.setQueryData(getAnswerStatisticQueryKey(answerId, patientId),
    updater
  );
}

/**
 * @param answerId ID of the requested answer
 * @param patientId (optional) Id of the patient for requested answer
 * @return Answer statistic
 */
export function setGetAnswerStatisticDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.AnswersStatisticsDto | undefined) => Types.AnswersStatisticsDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getAnswersUrl(patientIds?: string[] | null | undefined, surveyIds?: number[] | null | undefined, questionnaireIds?: number[] | null | undefined, answeredBy?: string[] | null | undefined, surveyTypes?: string[] | null | undefined, createdAfter?: Date | null | undefined, createdBefore?: Date | null | undefined, answerIds?: number[] | null | undefined): string {
  let url_ = getBaseUrl() + "/api/survey/answers?";
if (patientIds !== undefined && patientIds !== null)
    patientIds && patientIds.forEach(item => { url_ += "PatientIds=" + encodeURIComponent("" + item) + "&"; });
if (surveyIds !== undefined && surveyIds !== null)
    surveyIds && surveyIds.forEach(item => { url_ += "SurveyIds=" + encodeURIComponent("" + item) + "&"; });
if (questionnaireIds !== undefined && questionnaireIds !== null)
    questionnaireIds && questionnaireIds.forEach(item => { url_ += "QuestionnaireIds=" + encodeURIComponent("" + item) + "&"; });
if (answeredBy !== undefined && answeredBy !== null)
    answeredBy && answeredBy.forEach(item => { url_ += "AnsweredBy=" + encodeURIComponent("" + item) + "&"; });
if (surveyTypes !== undefined && surveyTypes !== null)
    surveyTypes && surveyTypes.forEach(item => { url_ += "SurveyTypes=" + encodeURIComponent("" + item) + "&"; });
if (createdAfter !== undefined && createdAfter !== null)
    url_ += "CreatedAfter=" + encodeURIComponent(createdAfter ? "" + createdAfter.toISOString() : "") + "&";
if (createdBefore !== undefined && createdBefore !== null)
    url_ += "CreatedBefore=" + encodeURIComponent(createdBefore ? "" + createdBefore.toISOString() : "") + "&";
if (answerIds !== undefined && answerIds !== null)
    answerIds && answerIds.forEach(item => { url_ += "AnswerIds=" + encodeURIComponent("" + item) + "&"; });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAnswersDefaultOptions: UseQueryOptions<Types.AnswerDto[], unknown, Types.AnswerDto[]> = {
  queryFn: __getAnswers,
};
export function getGetAnswersDefaultOptions(): UseQueryOptions<Types.AnswerDto[], unknown, Types.AnswerDto[]> {
  return getAnswersDefaultOptions;
};
export function setGetAnswersDefaultOptions(options: UseQueryOptions<Types.AnswerDto[], unknown, Types.AnswerDto[]>) {
  getAnswersDefaultOptions = options;
}

export function getAnswersQueryKey(dto: GetAnswersSurveyQueryParameters): QueryKey;
export function getAnswersQueryKey(patientIds?: string[] | null | undefined, surveyIds?: number[] | null | undefined, questionnaireIds?: number[] | null | undefined, answeredBy?: string[] | null | undefined, surveyTypes?: string[] | null | undefined, createdAfter?: Date | null | undefined, createdBefore?: Date | null | undefined, answerIds?: number[] | null | undefined): QueryKey;
export function getAnswersQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { patientIds, surveyIds, questionnaireIds, answeredBy, surveyTypes, createdAfter, createdBefore, answerIds,  } = params[0] as GetAnswersSurveyQueryParameters;

    return trimArrayEnd([
        'SurveyClient',
        'getAnswers',
        patientIds as any,
        surveyIds as any,
        questionnaireIds as any,
        answeredBy as any,
        surveyTypes as any,
        createdAfter as any,
        createdBefore as any,
        answerIds as any,
      ]);
  } else {
    return trimArrayEnd([
        'SurveyClient',
        'getAnswers',
        ...params
      ]);
  }
}
function __getAnswers(context: QueryFunctionContext) {
  return Client.getAnswers(
      context.queryKey[2] as string[] | null | undefined,       context.queryKey[3] as number[] | null | undefined,       context.queryKey[4] as number[] | null | undefined,       context.queryKey[5] as string[] | null | undefined,       context.queryKey[6] as string[] | null | undefined,       context.queryKey[7] as Date | null | undefined,       context.queryKey[8] as Date | null | undefined,       context.queryKey[9] as number[] | null | undefined    );
}

export function useGetAnswersQuery<TSelectData = Types.AnswerDto[], TError = unknown>(dto: GetAnswersSurveyQueryParameters, options?: UseQueryOptions<Types.AnswerDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param patientIds (optional) 
 * @param surveyIds (optional) 
 * @param questionnaireIds (optional) 
 * @param answeredBy (optional) Ids of the users who answered questionnaires
 * @param surveyTypes (optional) 
 * @param createdAfter (optional) 
 * @param createdBefore (optional) 
 * @param answerIds (optional) 
 */
export function useGetAnswersQuery<TSelectData = Types.AnswerDto[], TError = unknown>(patientIds?: string[] | null | undefined, surveyIds?: number[] | null | undefined, questionnaireIds?: number[] | null | undefined, answeredBy?: string[] | null | undefined, surveyTypes?: string[] | null | undefined, createdAfter?: Date | null | undefined, createdBefore?: Date | null | undefined, answerIds?: number[] | null | undefined, options?: UseQueryOptions<Types.AnswerDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAnswersQuery<TSelectData = Types.AnswerDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.AnswerDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let patientIds: any = undefined;
  let surveyIds: any = undefined;
  let questionnaireIds: any = undefined;
  let answeredBy: any = undefined;
  let surveyTypes: any = undefined;
  let createdAfter: any = undefined;
  let createdBefore: any = undefined;
  let answerIds: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ patientIds, surveyIds, questionnaireIds, answeredBy, surveyTypes, createdAfter, createdBefore, answerIds,  } = params[0] as GetAnswersSurveyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [patientIds, surveyIds, questionnaireIds, answeredBy, surveyTypes, createdAfter, createdBefore, answerIds, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.AnswerDto[], TError, TSelectData>({
    queryFn: __getAnswers,
    queryKey: getAnswersQueryKey(patientIds, surveyIds, questionnaireIds, answeredBy, surveyTypes, createdAfter, createdBefore, answerIds),
    ...getAnswersDefaultOptions as unknown as UseQueryOptions<Types.AnswerDto[], TError, TSelectData>,
    ...options,
  });
}
/**
 * @param patientIds (optional) 
 * @param surveyIds (optional) 
 * @param questionnaireIds (optional) 
 * @param answeredBy (optional) Ids of the users who answered questionnaires
 * @param surveyTypes (optional) 
 * @param createdAfter (optional) 
 * @param createdBefore (optional) 
 * @param answerIds (optional) 
 */
export function setGetAnswersData(queryClient: QueryClient, updater: (data: Types.AnswerDto[] | undefined) => Types.AnswerDto[], patientIds?: string[] | null | undefined, surveyIds?: number[] | null | undefined, questionnaireIds?: number[] | null | undefined, answeredBy?: string[] | null | undefined, surveyTypes?: string[] | null | undefined, createdAfter?: Date | null | undefined, createdBefore?: Date | null | undefined, answerIds?: number[] | null | undefined) {
  queryClient.setQueryData(getAnswersQueryKey(patientIds, surveyIds, questionnaireIds, answeredBy, surveyTypes, createdAfter, createdBefore, answerIds),
    updater
  );
}

/**
 * @param patientIds (optional) 
 * @param surveyIds (optional) 
 * @param questionnaireIds (optional) 
 * @param answeredBy (optional) Ids of the users who answered questionnaires
 * @param surveyTypes (optional) 
 * @param createdAfter (optional) 
 * @param createdBefore (optional) 
 * @param answerIds (optional) 
 */
export function setGetAnswersDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.AnswerDto[] | undefined) => Types.AnswerDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function saveAnswerUrl(awaitScoreCalculation?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/survey/answer?";
if (awaitScoreCalculation === null)
    throw new Error("The parameter 'awaitScoreCalculation' cannot be null.");
else if (awaitScoreCalculation !== undefined)
    url_ += "awaitScoreCalculation=" + encodeURIComponent("" + awaitScoreCalculation) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function saveAnswerMutationKey(awaitScoreCalculation?: boolean | undefined): MutationKey {
  return trimArrayEnd([
      'SurveyClient',
      'saveAnswer',
      awaitScoreCalculation as any,
    ]);
}

/**
 * Saves answer for given survey and user if it is possible (if it has NOT expired yet).
 * @param dto Answer DTO.
 * @param awaitScoreCalculation (optional) The flag indicates scoring should be awaited or not
 * @return Id of saved/created/updated answer entity.
 */
export function useSaveAnswerMutation<TContext>(awaitScoreCalculation?: boolean | undefined, options?: Omit<UseMutationOptions<number, unknown, Types.AnswerResultDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<number, unknown, Types.AnswerResultDto, TContext> {
  const key = saveAnswerMutationKey(awaitScoreCalculation);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.AnswerResultDto) => Client.saveAnswer(dto, awaitScoreCalculation), {...options, mutationKey: key});
}
  
    
export function recalculateScoreUrl(answerId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/survey/recalculateScore?";
if (answerId === null)
    throw new Error("The parameter 'answerId' cannot be null.");
else if (answerId !== undefined)
    url_ += "answerId=" + encodeURIComponent("" + answerId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function recalculateScoreMutationKey(answerId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'SurveyClient',
      'recalculateScore',
      answerId as any,
    ]);
}

/**
 * Trigger recalculation survey score
 * @param answerId (optional) 
 */
export function useRecalculateScoreMutation<TContext>(answerId?: number | undefined, options?: Omit<UseMutationOptions<number, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<number, unknown, void, TContext> {
  const key = recalculateScoreMutationKey(answerId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.recalculateScore(answerId), {...options, mutationKey: key});
}
  
    
export function createSurveyUrl(): string {
  let url_ = getBaseUrl() + "/api/survey";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createSurveyMutationKey(): MutationKey {
  return trimArrayEnd([
      'SurveyClient',
      'createSurvey',
    ]);
}

/**
 * Creates and returns survey for given study.
 * @param dto Params of created object.
 */
export function useCreateSurveyMutation<TContext>(options?: Omit<UseMutationOptions<Types.SurveyDto, unknown, Types.CreateSurveyDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.SurveyDto, unknown, Types.CreateSurveyDto, TContext> {
  const key = createSurveyMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.CreateSurveyDto) => Client.createSurvey(dto), {...options, mutationKey: key});
}
  
    
export function createSurveyRuleUrl(): string {
  let url_ = getBaseUrl() + "/api/survey/create/rule";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createSurveyRuleMutationKey(): MutationKey {
  return trimArrayEnd([
      'SurveyClient',
      'createSurveyRule',
    ]);
}

/**
 * Create a rule that contains the schedule of the survey and its belonging to a group
 * @param dto Params of created object.
 */
export function useCreateSurveyRuleMutation<TContext>(options?: Omit<UseMutationOptions<Types.SurveyRuleDto, unknown, Types.CreateSurveyRuleDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.SurveyRuleDto, unknown, Types.CreateSurveyRuleDto, TContext> {
  const key = createSurveyRuleMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.CreateSurveyRuleDto) => Client.createSurveyRule(dto), {...options, mutationKey: key});
}
  
    
export function getQuestionnairesUrl(patientId?: string | null | undefined, surveyIds?: number[] | null | undefined, triggeredByCurrentUser?: boolean | null | undefined, triggeredByDoctor?: boolean | null | undefined, triggeredByPatient?: boolean | null | undefined, ended?: boolean | null | undefined, active?: boolean | null | undefined, completed?: boolean | null | undefined, canBeFilledByDoctor?: boolean | null | undefined, forDisplayToPatient?: boolean | null | undefined): string {
  let url_ = getBaseUrl() + "/api/survey/questionnaires?";
if (patientId !== undefined && patientId !== null)
    url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
if (surveyIds !== undefined && surveyIds !== null)
    surveyIds && surveyIds.forEach(item => { url_ += "SurveyIds=" + encodeURIComponent("" + item) + "&"; });
if (triggeredByCurrentUser !== undefined && triggeredByCurrentUser !== null)
    url_ += "TriggeredByCurrentUser=" + encodeURIComponent("" + triggeredByCurrentUser) + "&";
if (triggeredByDoctor !== undefined && triggeredByDoctor !== null)
    url_ += "TriggeredByDoctor=" + encodeURIComponent("" + triggeredByDoctor) + "&";
if (triggeredByPatient !== undefined && triggeredByPatient !== null)
    url_ += "TriggeredByPatient=" + encodeURIComponent("" + triggeredByPatient) + "&";
if (ended !== undefined && ended !== null)
    url_ += "Ended=" + encodeURIComponent("" + ended) + "&";
if (active !== undefined && active !== null)
    url_ += "Active=" + encodeURIComponent("" + active) + "&";
if (completed !== undefined && completed !== null)
    url_ += "Completed=" + encodeURIComponent("" + completed) + "&";
if (canBeFilledByDoctor !== undefined && canBeFilledByDoctor !== null)
    url_ += "CanBeFilledByDoctor=" + encodeURIComponent("" + canBeFilledByDoctor) + "&";
if (forDisplayToPatient !== undefined && forDisplayToPatient !== null)
    url_ += "ForDisplayToPatient=" + encodeURIComponent("" + forDisplayToPatient) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getQuestionnairesDefaultOptions: UseQueryOptions<Types.QuestionnaireDto[], unknown, Types.QuestionnaireDto[]> = {
  queryFn: __getQuestionnaires,
};
export function getGetQuestionnairesDefaultOptions(): UseQueryOptions<Types.QuestionnaireDto[], unknown, Types.QuestionnaireDto[]> {
  return getQuestionnairesDefaultOptions;
};
export function setGetQuestionnairesDefaultOptions(options: UseQueryOptions<Types.QuestionnaireDto[], unknown, Types.QuestionnaireDto[]>) {
  getQuestionnairesDefaultOptions = options;
}

export function getQuestionnairesQueryKey(dto: GetQuestionnairesSurveyQueryParameters): QueryKey;
export function getQuestionnairesQueryKey(patientId?: string | null | undefined, surveyIds?: number[] | null | undefined, triggeredByCurrentUser?: boolean | null | undefined, triggeredByDoctor?: boolean | null | undefined, triggeredByPatient?: boolean | null | undefined, ended?: boolean | null | undefined, active?: boolean | null | undefined, completed?: boolean | null | undefined, canBeFilledByDoctor?: boolean | null | undefined, forDisplayToPatient?: boolean | null | undefined): QueryKey;
export function getQuestionnairesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { patientId, surveyIds, triggeredByCurrentUser, triggeredByDoctor, triggeredByPatient, ended, active, completed, canBeFilledByDoctor, forDisplayToPatient,  } = params[0] as GetQuestionnairesSurveyQueryParameters;

    return trimArrayEnd([
        'SurveyClient',
        'getQuestionnaires',
        patientId as any,
        surveyIds as any,
        triggeredByCurrentUser as any,
        triggeredByDoctor as any,
        triggeredByPatient as any,
        ended as any,
        active as any,
        completed as any,
        canBeFilledByDoctor as any,
        forDisplayToPatient as any,
      ]);
  } else {
    return trimArrayEnd([
        'SurveyClient',
        'getQuestionnaires',
        ...params
      ]);
  }
}
function __getQuestionnaires(context: QueryFunctionContext) {
  return Client.getQuestionnaires(
      context.queryKey[2] as string | null | undefined,       context.queryKey[3] as number[] | null | undefined,       context.queryKey[4] as boolean | null | undefined,       context.queryKey[5] as boolean | null | undefined,       context.queryKey[6] as boolean | null | undefined,       context.queryKey[7] as boolean | null | undefined,       context.queryKey[8] as boolean | null | undefined,       context.queryKey[9] as boolean | null | undefined,       context.queryKey[10] as boolean | null | undefined,       context.queryKey[11] as boolean | null | undefined    );
}

export function useGetQuestionnairesQuery<TSelectData = Types.QuestionnaireDto[], TError = unknown>(dto: GetQuestionnairesSurveyQueryParameters, options?: UseQueryOptions<Types.QuestionnaireDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetQuestionnairesQuery<TSelectData = Types.QuestionnaireDto[], TError = unknown>(patientId?: string | null | undefined, surveyIds?: number[] | null | undefined, triggeredByCurrentUser?: boolean | null | undefined, triggeredByDoctor?: boolean | null | undefined, triggeredByPatient?: boolean | null | undefined, ended?: boolean | null | undefined, active?: boolean | null | undefined, completed?: boolean | null | undefined, canBeFilledByDoctor?: boolean | null | undefined, forDisplayToPatient?: boolean | null | undefined, options?: UseQueryOptions<Types.QuestionnaireDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuestionnairesQuery<TSelectData = Types.QuestionnaireDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.QuestionnaireDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let patientId: any = undefined;
  let surveyIds: any = undefined;
  let triggeredByCurrentUser: any = undefined;
  let triggeredByDoctor: any = undefined;
  let triggeredByPatient: any = undefined;
  let ended: any = undefined;
  let active: any = undefined;
  let completed: any = undefined;
  let canBeFilledByDoctor: any = undefined;
  let forDisplayToPatient: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ patientId, surveyIds, triggeredByCurrentUser, triggeredByDoctor, triggeredByPatient, ended, active, completed, canBeFilledByDoctor, forDisplayToPatient,  } = params[0] as GetQuestionnairesSurveyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [patientId, surveyIds, triggeredByCurrentUser, triggeredByDoctor, triggeredByPatient, ended, active, completed, canBeFilledByDoctor, forDisplayToPatient, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.QuestionnaireDto[], TError, TSelectData>({
    queryFn: __getQuestionnaires,
    queryKey: getQuestionnairesQueryKey(patientId, surveyIds, triggeredByCurrentUser, triggeredByDoctor, triggeredByPatient, ended, active, completed, canBeFilledByDoctor, forDisplayToPatient),
    ...getQuestionnairesDefaultOptions as unknown as UseQueryOptions<Types.QuestionnaireDto[], TError, TSelectData>,
    ...options,
  });
}

export function setGetQuestionnairesData(queryClient: QueryClient, updater: (data: Types.QuestionnaireDto[] | undefined) => Types.QuestionnaireDto[], patientId?: string | null | undefined, surveyIds?: number[] | null | undefined, triggeredByCurrentUser?: boolean | null | undefined, triggeredByDoctor?: boolean | null | undefined, triggeredByPatient?: boolean | null | undefined, ended?: boolean | null | undefined, active?: boolean | null | undefined, completed?: boolean | null | undefined, canBeFilledByDoctor?: boolean | null | undefined, forDisplayToPatient?: boolean | null | undefined) {
  queryClient.setQueryData(getQuestionnairesQueryKey(patientId, surveyIds, triggeredByCurrentUser, triggeredByDoctor, triggeredByPatient, ended, active, completed, canBeFilledByDoctor, forDisplayToPatient),
    updater
  );
}

export function setGetQuestionnairesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.QuestionnaireDto[] | undefined) => Types.QuestionnaireDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function createQuestionnaireUrl(patientId: string, surveyId: number, startDate: Date, endDate: Date): string {
  let url_ = getBaseUrl() + "/api/survey/questionnaires?";
  if (patientId === undefined || patientId === null)
    throw new Error("The parameter 'patientId' must be defined and cannot be null.");
  else
    url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
  if (surveyId === undefined || surveyId === null)
    throw new Error("The parameter 'surveyId' must be defined and cannot be null.");
  else
    url_ += "surveyId=" + encodeURIComponent("" + surveyId) + "&";
  if (startDate === undefined || startDate === null)
    throw new Error("The parameter 'startDate' must be defined and cannot be null.");
  else
    url_ += "startDate=" + encodeURIComponent(startDate ? "" + Types.formatDate(startDate) : "") + "&";
  if (endDate === undefined || endDate === null)
    throw new Error("The parameter 'endDate' must be defined and cannot be null.");
  else
    url_ += "endDate=" + encodeURIComponent(endDate ? "" + Types.formatDate(endDate) : "") + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createQuestionnaireMutationKey(patientId: string, surveyId: number, startDate: Date, endDate: Date): MutationKey {
  return trimArrayEnd([
      'SurveyClient',
      'createQuestionnaire',
      patientId as any,
      surveyId as any,
      startDate as any,
      endDate as any,
    ]);
}

/**
 * Create new questionnaire
 * @param patientId Patient ID
 * @param surveyId Survey ID
 * @param startDate Questionnaire start date
 * @param endDate Questionnaire end date
 */
export function useCreateQuestionnaireMutation<TContext>(patientId: string, surveyId: number, startDate: Date, endDate: Date, options?: Omit<UseMutationOptions<Types.QuestionnaireDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.QuestionnaireDto, unknown, void, TContext> {
  const key = createQuestionnaireMutationKey(patientId, surveyId, startDate, endDate);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.createQuestionnaire(patientId, surveyId, startDate, endDate), {...options, mutationKey: key});
}
  
    
export function getPredictedQuestionnairesUrl(patientId?: string | undefined, surveyIds?: number[] | null | undefined): string {
  let url_ = getBaseUrl() + "/api/survey/questionnaires/predicted?";
if (patientId === null)
    throw new Error("The parameter 'patientId' cannot be null.");
else if (patientId !== undefined)
    url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
if (surveyIds !== undefined && surveyIds !== null)
    surveyIds && surveyIds.forEach(item => { url_ += "SurveyIds=" + encodeURIComponent("" + item) + "&"; });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPredictedQuestionnairesDefaultOptions: UseQueryOptions<Types.PredictedQuestionnaireDto[], unknown, Types.PredictedQuestionnaireDto[]> = {
  queryFn: __getPredictedQuestionnaires,
};
export function getGetPredictedQuestionnairesDefaultOptions(): UseQueryOptions<Types.PredictedQuestionnaireDto[], unknown, Types.PredictedQuestionnaireDto[]> {
  return getPredictedQuestionnairesDefaultOptions;
};
export function setGetPredictedQuestionnairesDefaultOptions(options: UseQueryOptions<Types.PredictedQuestionnaireDto[], unknown, Types.PredictedQuestionnaireDto[]>) {
  getPredictedQuestionnairesDefaultOptions = options;
}

export function getPredictedQuestionnairesQueryKey(dto: GetPredictedQuestionnairesSurveyQueryParameters): QueryKey;
export function getPredictedQuestionnairesQueryKey(patientId?: string | undefined, surveyIds?: number[] | null | undefined): QueryKey;
export function getPredictedQuestionnairesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { patientId, surveyIds,  } = params[0] as GetPredictedQuestionnairesSurveyQueryParameters;

    return trimArrayEnd([
        'SurveyClient',
        'getPredictedQuestionnaires',
        patientId as any,
        surveyIds as any,
      ]);
  } else {
    return trimArrayEnd([
        'SurveyClient',
        'getPredictedQuestionnaires',
        ...params
      ]);
  }
}
function __getPredictedQuestionnaires(context: QueryFunctionContext) {
  return Client.getPredictedQuestionnaires(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as number[] | null | undefined    );
}

export function useGetPredictedQuestionnairesQuery<TSelectData = Types.PredictedQuestionnaireDto[], TError = unknown>(dto: GetPredictedQuestionnairesSurveyQueryParameters, options?: UseQueryOptions<Types.PredictedQuestionnaireDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param patientId (optional) An id of a Patient that we get the prediction for
 * @param surveyIds (optional) Ids of Surveys that the prediction must be filtered by
 */
export function useGetPredictedQuestionnairesQuery<TSelectData = Types.PredictedQuestionnaireDto[], TError = unknown>(patientId?: string | undefined, surveyIds?: number[] | null | undefined, options?: UseQueryOptions<Types.PredictedQuestionnaireDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPredictedQuestionnairesQuery<TSelectData = Types.PredictedQuestionnaireDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PredictedQuestionnaireDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let patientId: any = undefined;
  let surveyIds: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ patientId, surveyIds,  } = params[0] as GetPredictedQuestionnairesSurveyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [patientId, surveyIds, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.PredictedQuestionnaireDto[], TError, TSelectData>({
    queryFn: __getPredictedQuestionnaires,
    queryKey: getPredictedQuestionnairesQueryKey(patientId, surveyIds),
    ...getPredictedQuestionnairesDefaultOptions as unknown as UseQueryOptions<Types.PredictedQuestionnaireDto[], TError, TSelectData>,
    ...options,
  });
}
/**
 * @param patientId (optional) An id of a Patient that we get the prediction for
 * @param surveyIds (optional) Ids of Surveys that the prediction must be filtered by
 */
export function setGetPredictedQuestionnairesData(queryClient: QueryClient, updater: (data: Types.PredictedQuestionnaireDto[] | undefined) => Types.PredictedQuestionnaireDto[], patientId?: string | undefined, surveyIds?: number[] | null | undefined) {
  queryClient.setQueryData(getPredictedQuestionnairesQueryKey(patientId, surveyIds),
    updater
  );
}

/**
 * @param patientId (optional) An id of a Patient that we get the prediction for
 * @param surveyIds (optional) Ids of Surveys that the prediction must be filtered by
 */
export function setGetPredictedQuestionnairesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PredictedQuestionnaireDto[] | undefined) => Types.PredictedQuestionnaireDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function deleteQuestionnaireUrl(questionnaireId: number): string {
  let url_ = getBaseUrl() + "/api/survey/questionnaires/{questionnaireId}";
if (questionnaireId === undefined || questionnaireId === null)
  throw new Error("The parameter 'questionnaireId' must be defined.");
url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteQuestionnaireMutationKey(questionnaireId: number): MutationKey {
  return trimArrayEnd([
      'SurveyClient',
      'deleteQuestionnaire',
      questionnaireId as any,
    ]);
}

export function useDeleteQuestionnaireMutation<TContext>(questionnaireId: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteQuestionnaireMutationKey(questionnaireId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.deleteQuestionnaire(questionnaireId), {...options, mutationKey: key});
}
  
    
export function getSurveyRecordsForPatientUrl(surveyType?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/survey/records?";
if (surveyType === null)
    throw new Error("The parameter 'surveyType' cannot be null.");
else if (surveyType !== undefined)
    url_ += "surveyType=" + encodeURIComponent("" + surveyType) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getSurveyRecordsForPatientDefaultOptions: UseQueryOptions<Types.AnswerDto[], unknown, Types.AnswerDto[]> = {
  queryFn: __getSurveyRecordsForPatient,
};
export function getGetSurveyRecordsForPatientDefaultOptions(): UseQueryOptions<Types.AnswerDto[], unknown, Types.AnswerDto[]> {
  return getSurveyRecordsForPatientDefaultOptions;
};
export function setGetSurveyRecordsForPatientDefaultOptions(options: UseQueryOptions<Types.AnswerDto[], unknown, Types.AnswerDto[]>) {
  getSurveyRecordsForPatientDefaultOptions = options;
}

export function getSurveyRecordsForPatientQueryKey(surveyType?: string | undefined): QueryKey;
export function getSurveyRecordsForPatientQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { surveyType,  } = params[0] as GetSurveyRecordsForPatientSurveyQueryParameters;

    return trimArrayEnd([
        'SurveyClient',
        'getSurveyRecordsForPatient',
        surveyType as any,
      ]);
  } else {
    return trimArrayEnd([
        'SurveyClient',
        'getSurveyRecordsForPatient',
        ...params
      ]);
  }
}
function __getSurveyRecordsForPatient(context: QueryFunctionContext) {
  return Client.getSurveyRecordsForPatient(
      context.queryKey[2] as string | undefined    );
}

export function useGetSurveyRecordsForPatientQuery<TSelectData = Types.AnswerDto[], TError = unknown>(dto: GetSurveyRecordsForPatientSurveyQueryParameters, options?: UseQueryOptions<Types.AnswerDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get survey results (answers) for the patient
 * @param surveyType (optional) 
 * @deprecated
 */
export function useGetSurveyRecordsForPatientQuery<TSelectData = Types.AnswerDto[], TError = unknown>(surveyType?: string | undefined, options?: UseQueryOptions<Types.AnswerDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetSurveyRecordsForPatientQuery<TSelectData = Types.AnswerDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.AnswerDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let surveyType: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ surveyType,  } = params[0] as GetSurveyRecordsForPatientSurveyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [surveyType, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.AnswerDto[], TError, TSelectData>({
    queryFn: __getSurveyRecordsForPatient,
    queryKey: getSurveyRecordsForPatientQueryKey(surveyType),
    ...getSurveyRecordsForPatientDefaultOptions as unknown as UseQueryOptions<Types.AnswerDto[], TError, TSelectData>,
    ...options,
  });
}
/**
 * Get survey results (answers) for the patient
 * @param surveyType (optional) 
 * @deprecated
 */
export function setGetSurveyRecordsForPatientData(queryClient: QueryClient, updater: (data: Types.AnswerDto[] | undefined) => Types.AnswerDto[], surveyType?: string | undefined) {
  queryClient.setQueryData(getSurveyRecordsForPatientQueryKey(surveyType),
    updater
  );
}

/**
 * Get survey results (answers) for the patient
 * @param surveyType (optional) 
 * @deprecated
 */
export function setGetSurveyRecordsForPatientDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.AnswerDto[] | undefined) => Types.AnswerDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getSurveyRulesByStudyUrl(studyId: number, groupId?: number | null | undefined): string {
  let url_ = getBaseUrl() + "/api/survey/rules/{studyId}?";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
if (groupId !== undefined && groupId !== null)
    url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getSurveyRulesByStudyDefaultOptions: UseQueryOptions<Types.SurveyRuleDto[], unknown, Types.SurveyRuleDto[]> = {
  queryFn: __getSurveyRulesByStudy,
};
export function getGetSurveyRulesByStudyDefaultOptions(): UseQueryOptions<Types.SurveyRuleDto[], unknown, Types.SurveyRuleDto[]> {
  return getSurveyRulesByStudyDefaultOptions;
};
export function setGetSurveyRulesByStudyDefaultOptions(options: UseQueryOptions<Types.SurveyRuleDto[], unknown, Types.SurveyRuleDto[]>) {
  getSurveyRulesByStudyDefaultOptions = options;
}

export function getSurveyRulesByStudyQueryKey(dto: GetSurveyRulesByStudySurveyQueryParameters): QueryKey;
export function getSurveyRulesByStudyQueryKey(studyId: number, groupId?: number | null | undefined): QueryKey;
export function getSurveyRulesByStudyQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId, groupId,  } = params[0] as GetSurveyRulesByStudySurveyQueryParameters;

    return trimArrayEnd([
        'SurveyClient',
        'getSurveyRulesByStudy',
        studyId as any,
        groupId as any,
      ]);
  } else {
    return trimArrayEnd([
        'SurveyClient',
        'getSurveyRulesByStudy',
        ...params
      ]);
  }
}
function __getSurveyRulesByStudy(context: QueryFunctionContext) {
  return Client.getSurveyRulesByStudy(
      context.queryKey[2] as number,       context.queryKey[3] as number | null | undefined    );
}

export function useGetSurveyRulesByStudyQuery<TSelectData = Types.SurveyRuleDto[], TError = unknown>(dto: GetSurveyRulesByStudySurveyQueryParameters, options?: UseQueryOptions<Types.SurveyRuleDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns list of available SurveyRules for study. Could be filtered by group of study.
 * @param studyId Requested Study
 * @param groupId (optional) Optional filter by group.
 */
export function useGetSurveyRulesByStudyQuery<TSelectData = Types.SurveyRuleDto[], TError = unknown>(studyId: number, groupId?: number | null | undefined, options?: UseQueryOptions<Types.SurveyRuleDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetSurveyRulesByStudyQuery<TSelectData = Types.SurveyRuleDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.SurveyRuleDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  let groupId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId, groupId,  } = params[0] as GetSurveyRulesByStudySurveyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, groupId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.SurveyRuleDto[], TError, TSelectData>({
    queryFn: __getSurveyRulesByStudy,
    queryKey: getSurveyRulesByStudyQueryKey(studyId, groupId),
    ...getSurveyRulesByStudyDefaultOptions as unknown as UseQueryOptions<Types.SurveyRuleDto[], TError, TSelectData>,
    ...options,
  });
}
/**
 * Returns list of available SurveyRules for study. Could be filtered by group of study.
 * @param studyId Requested Study
 * @param groupId (optional) Optional filter by group.
 */
export function setGetSurveyRulesByStudyData(queryClient: QueryClient, updater: (data: Types.SurveyRuleDto[] | undefined) => Types.SurveyRuleDto[], studyId: number, groupId?: number | null | undefined) {
  queryClient.setQueryData(getSurveyRulesByStudyQueryKey(studyId, groupId),
    updater
  );
}

/**
 * Returns list of available SurveyRules for study. Could be filtered by group of study.
 * @param studyId Requested Study
 * @param groupId (optional) Optional filter by group.
 */
export function setGetSurveyRulesByStudyDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.SurveyRuleDto[] | undefined) => Types.SurveyRuleDto[]) {
  queryClient.setQueryData(queryKey, updater);
}